<template>
  <div class="details-component" v-if="isLandlord() || pricingrules.length > 0">
    <div class="details-component__header">
      <h1>{{ $t('pricingrules.price_rules') }}</h1>
      <div class="details-component__header_right" v-if="isLandlord()">
        <router-link :to="{name: 'add-pricingrule'}" class="link">
          {{ $t('pricingrules.add_rule') }}
          <i class="icon icon--plus"></i>
        </router-link>
      </div>
    </div>
    <div class="rule" v-for="rule in pricingrules">
      <div class="remove">
        <a v-if="isLandlord()" v-on:click="showDeletingConfirmation(rule.id)" class="link link--orange">{{ $t('common.delete') }}&nbsp;<i class="icon icon--cross"></i>
        </a>
      </div>
      <div class="edit" v-if="isLandlord()">
        <router-link :to="{name: 'edit-pricingrule', params: { ruleId: rule.id }}" class="link">
          {{ $t('common.change') }}
          <i class="icon icon--arrow"></i>
        </router-link>
      </div>
      <div class="period">
        <template>{{ getWeekdaysAsString(rule.weekdays) }} </template>
        <template>{{ formatTime(rule.startMinutes) }} - {{ formatTime(rule.endMinutes) }} </template>
        <span class="datePeriod" v-if="rule.startDate || rule.endDate">({{ formatDate(rule.startDate) }} - {{ formatDate(rule.endDate) }})</span>
      </div>
      <hr>
      <div class="table">
        <table class="ruletable">
        <tr v-if="rule.startingPrice"><td>
          {{ $t('pricingrules.starting_price') }}</td><td class="price">{{ rule.startingPrice.toFixed(2) }} {{currency_short}}
        </td></tr>
        <!--<tr v-if="rule.minPrice"><td>
          {{ $t('pricingrules.min_price') }}</td><td class="price">{{ rule.minPrice.toFixed(2) }} {{currency_short}}
        </td></tr>-->
        <template v-for="step in rule.steps">
          <tr v-for="(price, priceIndex) in step.prices"><td :style="priceIndex > 0 ? 'color: #fff' : ''">
            {{ $t('pricingrules.every_started') }} {{ formatPeriod(step.step, step.unit) }}
            <span class="priceafter" v-if="price.after">{{ $t('pricingrules.after') }} {{ formatPeriod(price.after, price.unit) }}</span>
            <span class="priceafter" v-else></span>
            </td><td class="price">{{ price.price.toFixed(2) }} {{currency_short}}
          </td></tr>
        </template>
        <tr v-if="rule.maxPrice"><td>
          {{ $t('pricingrules.max_price') }}</td><td class="price">{{ rule.maxPrice.toFixed(2) }} {{currency_short}}
        </td></tr>
        <tr v-if="rule.maxMinutes && !rule.maxTime"><td>
          {{ $t('pricingrules.max_minutes') }}</td><td class="price">{{ formatPeriod(rule.maxMinutes) }}
        </td></tr>
          <tr v-if="rule.maxTime"><td>
            {{ $t('pricingrules.max_time') }}</td><td class="price">{{ rule.maxTime }}
          </td></tr>
        </table>
      </div>
    </div>
    <ConfirmationModal v-if="showConfirmationModal" @cancel="cancelPricingRuleDelete" @confirmed="deletePricingRule">
      <h1 slot="header">{{ $t('common.deleting') }}</h1>
      <p slot="body">{{ $t('pricingrules.confirm_delete') }}</p>
    </ConfirmationModal>
    <WarningModal v-if="showWarningModal" @close="closeWarningModal">
      <h1 slot="header">{{ $t('pricingrules.delete_error_header') }}</h1>
      <p slot="body">{{ $t('pricingrules.delete_error_body') }}</p>
    </WarningModal>
    <br>
    <div class="details-component__header" v-if="hasSteps()">
      <h1>{{ $t('pricingtest.heading') }}</h1>
    </div>
    <div class="pricetest" v-if="hasSteps()">
      <label>{{ $t('pricingtest.startday') }}</label>
      <el-date-picker
        v-model="priceTestData.startTime"
        type="datetime"
        :picker-options="pickerOptions"
        placeholder=""></el-date-picker><br>
      <label>{{ $t('pricingtest.endday') }}</label>{{ priceTestData.endTime | formatDateWithWeekday }}<br/>
      <label>{{ $t('pricingtest.parkingtime') }}</label><input min="0" step="0" max="72000" type="number" v-model="priceTestData.parkingTime"> {{ $t('pricingtest.minutes') }} ({{ formatPeriod(priceTestData.parkingTime) }})<br/>
      <vue-slider @callback="priceTestSliderEvent" ref="priceTestSlider" v-bind="priceTestData.slider" v-model="priceTestData.slider.value"></vue-slider>
      <label>{{ $t('pricingtest.parkingcost') }}</label>
        <span v-if="priceTestData.result.cappedPrice && priceTestData.result.price > priceTestData.result.cappedPrice"><b>{{ priceTestData.result.cappedPrice.toFixed(2) }} {{currency_short}}</b></span>
        <span v-else-if="priceTestData.result.price"><b>{{ priceTestData.result.price.toFixed(2) }} {{currency_short}}</b></span>
      <br/>
      <label>{{ $t('pricingtest.parkingcostdetails') }}</label><div class="testDetails">
        <div v-for="row in priceTestData.result.rows">
          <div v-if="row.startingPrice">{{ $t('pricingtest.rulenr') + ' ' + row.ruleNr }}: {{ $t('pricingtest.startingprice') }} <b>{{ row.price.toFixed(2) }} {{currency_short}}</b></div>
          <!--<div v-else-if="row.maxPrice">{{ $t('pricingtest.rulenr') + ' ' + row.ruleNr }}: {{ $t('pricingtest.maxprice') }} <b>{{ row.price.toFixed(2) }} {{currency_short}}</b></div>-->
          <div v-else-if="row.maxTime">{{ $t('pricingtest.rulenr') + ' ' + row.ruleNr }}: {{ $t('pricingtest.maxtime') }} <b>{{ formatDate(row.maxTime) }}</b></div>
          <div v-else-if="row.maxMinutes">{{ $t('pricingtest.rulenr') + ' ' + row.ruleNr }}: {{ $t('pricingtest.maxduration') }} <b>{{ formatPeriod(row.maxMinutes) }}</b></div>
          <div v-else>{{ row.ruleNr > 0 ? $t('pricingtest.rulenr') + ' ' + row.ruleNr : $t('pricingtest.norule') }}: {{ formatDate(row.from) }} - {{ formatDate(row.to) }}
            = {{ formatPeriod(row.step/* , row.unit*/) }} @ <b>{{ row.price.toFixed(2) }} {{currency_short}}</b>
            <span v-if="row.maxPrice">{{ $t('pricingtest.max_day_price') }}</span>
          </div>
        </div>
        <div v-if="priceTestData.result.hasEnded">{{ $t('pricingtest.hasended') }} <b>{{ formatDate(priceTestData.result.endTime) }}</b></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import ConfirmationModal from 'common/ConfirmationModal';
import WarningModal from 'common/WarningModal';
import * as mTypes from 'store/mutation-types';
import vueSlider from 'vue-slider-component';

export default {
  components: {
    ConfirmationModal,
    WarningModal,
    vueSlider,
  },
  computed: mapGetters({
    pricingrules: 'pricingrules/pricingrules/pricingrules',
    user: 'user/user/user',
    error: 'pricingrules/pricingrule/error',
  }),
  watch: {
    $route: 'fetchPricingRules',
    'priceTestData.parkingTime': 'priceTestPeriodChanged',
  },
  route: {
    canReuse: true,
  },
  created() {
    if (this.$route.params.id) {
      this.fetchPricingRules();
    }
  },
  methods: {
    showDeletingConfirmation(id) {
      this.deleteRuleId = id;
      this.showConfirmationModal = true;
    },
    cancelPricingRuleDelete() {
      this.deleteRuleId = null;
      this.showConfirmationModal = false;
    },
    deletePricingRule() {
      this.showConfirmationModal = false;
      this.$store.dispatch('pricingrules/pricingrule/delete', { id: this.deleteRuleId, user: this.user, productId: this.$route.params.id }).then(() => {
        if (!this.error) {
          this.$store.commit(`pricingrules/pricingrules/${mTypes.REMOVE_DATA}`, this.deleteRuleId);
        } else {
          this.showWarningModal = true;
        }
        this.deleteRuleId = null;
      });
    },
    closeWarningModal() {
      this.showWarningModal = false;
      this.$store.commit(`pricingrules/pricingrule/${mTypes.DATA_ERROR}`, null);
    },
    fetchPricingRules() {
      if (this.$route.params.id && this.user.data) {
        this.$store.dispatch('pricingrules/pricingrules/fetch', { id: this.$route.params.id, user: this.user, limit: 100 });
      }
    },
    getWeekdaysAsString(arr) {
      if (!arr) {
        return this.$t('pricingrules.notactive');
      }
      const min = Math.min.apply(null, arr);
      const max = Math.max.apply(null, arr);
      if (arr.length === 1) {
        return this.$t(`pricingrules.weekdays.${arr[0]}`);
      }
      if (this.hasConsecutiveWeekdays(arr, min, max)) {
        if (min === 0 && max === 6) {
          return '';
        }
        return `${this.$t(`pricingrules.weekdays.${min}`)} - ${this.$t(`pricingrules.weekdays.${max}`)}`;
      }
      return arr.join(', ')
        .replace('0', this.$t('pricingrules.weekdays.0'))
        .replace('1', this.$t('pricingrules.weekdays.1'))
        .replace('2', this.$t('pricingrules.weekdays.2'))
        .replace('3', this.$t('pricingrules.weekdays.3'))
        .replace('4', this.$t('pricingrules.weekdays.4'))
        .replace('5', this.$t('pricingrules.weekdays.5'))
        .replace('6', this.$t('pricingrules.weekdays.6'));
    },
    hasConsecutiveWeekdays(arr, min, max) {
      for (let i = min + 1; i < max; i += 1) {
        if (arr.indexOf(i) === -1) {
          return false;
        }
      }
      return true;
    },
    formatTime(minutes) {
      const hours = Math.floor(minutes / this.minutes_in_hour);
      let min = minutes - (hours * this.minutes_in_hour);
      min = `0${min}`;
      return `${hours}:${(min).substr(-2)}`;
    },
    formatDate(momentDate) {
      return momentDate == null ? '*' : moment(momentDate).format(this.date_time_format);
    },
    formatPeriod(minutes, unit) {
      if (unit === 'month') {
        return `${minutes} ${this.$tc('pricingrules.month', minutes)}`;
      }
      let min = minutes;
      let days = Math.floor(min / this.minutes_in_day);
      min -= days * this.minutes_in_day;
      let hours = Math.floor(min / this.minutes_in_hour);
      min -= hours * this.minutes_in_hour;
      if (days === 1) {
        days = `${days} ${this.$tc('pricingrules.day', 1)} `;
      } else if (days > 1) {
        days = `${days} ${this.$tc('pricingrules.day', 2)} `;
      } else {
        days = '';
      }
      if (hours) {
        hours = `${hours} ${this.$t('pricingrules.hour')} `;
      } else {
        hours = '';
      }
      if (min) {
        min = `${min} ${this.$t('pricingrules.minute')} `;
      } else {
        min = '';
      }
      return (days + hours + min).trim();
    },
    /**
     *  Returns the minimum price of:
     *  - the price of smallest possible step that cover the whole period or sum of the prices of
     *    steps covering the whole period
     *  - the same as previous but last step one unit smaller
     *  For example if there are steps 15 and 60 and whole amount of minutes is 80 then finds the
     *  minimum price of periods:
     *  - 60 + 60
     *  - 60 + 15 + 15
     *
     *  Returns {price: x, rows: x}
     */
    calculatePrice(startTime, minutesParam, maxStepParam, notFirstRecursiveParam, previousData) {
      const ret = { price: 0, rows: [], previousPrice: 0, processedMinutes: 0 };
      if (previousData) {
        ret.processedMinutes = previousData.processedMinutes;
        ret.previousPrice = previousData.price + previousData.previousPrice;
      }
      let curStartTime = moment(startTime);
      let curTime = moment(startTime);
      const maxStep = maxStepParam || { step: 9999999, unit: 'minute' };
      let notFirstRecursive = notFirstRecursiveParam;
      let minutes = minutesParam;

      let minutesFromStart = 0;
      let lastStep = null;
      let lastUnit = null;
      let monthlyStartTime = null;
      let prevTime = null;
      let dayPriceLimit = null;

      while (minutesFromStart < minutes) {
        prevTime = curTime;
        curTime = moment(curStartTime).add(minutesFromStart, 'm');
        ret.ruleIndex = this.getPricingRuleIndex(this.pricingrules, curTime);
        const curRule = this.pricingrules[ret.ruleIndex];
        let fullStepPrice = 0;
        const fullStepRows = [];

        // Has day changed
        if (!notFirstRecursive || curTime.format('Y-M-D') !== prevTime.format('Y-M-D')) {
          dayPriceLimit = curRule.maxPrice;
        }

        // Has starting price
        if (!notFirstRecursive && curRule.startingPrice) {
          fullStepPrice = curRule.startingPrice;
          fullStepRows.push({
            ruleNr: ret.ruleIndex + 1,
            startingPrice: true,
            price: fullStepPrice,
          });
        }

        /* TODO: doesn't work correctly when next rule has after, it starts from 0
        // Can change to a longer step if it costs less
        if (previousData && ret.ruleIndex != previousData.ruleIndex) {
            maxStep.step = 9999999;
            maxStep.unit = undefined;
        } */

        // Check max parking price. Doesn't find best fit if parking a lot more than expected
        // parking end time
        // if (curRule.maxPrice) {
        //   maxStep.step = Math.min(maxStep.step, this.getMaxStep(curRule.maxPrice
        //       - ret.previousPrice - ret.price - fullStepPrice, curRule.steps));
        // }

        // Check for curRule.maxTime and convert it to maxMinutes -- hack but is equivalent
        let maxTimeDate;
        if (curRule.maxTime !== '') {
          maxTimeDate = curStartTime.clone().hour(curRule.maxTime.split(':')[0]).minute(curRule.maxTime.split(':')[1]);
          if (maxTimeDate.isBefore(curStartTime)) {
            maxTimeDate.add({ days: 1 });
          }
          curRule.maxMinutes = maxTimeDate.diff(curStartTime, 'minutes');
        }


        const steps = this.findStepsAround(curRule.steps, minutes - minutesFromStart, maxStep
          , curTime, monthlyStartTime);
        const fullStep = steps[0];
        if (!fullStep) { break; }
        const subStep = steps[1];
        let subStepData = null;
        if (subStep && minutes - minutesFromStart < fullStep.realStep) {
          subStepData = this.calculatePrice(curTime, minutes - minutesFromStart, subStep
            , notFirstRecursive, ret);
        }
        notFirstRecursive = true;

        let step = fullStep.step;
        const unit = fullStep.unit;
        // If different size step then restart time counting from 0
        if (lastStep != null && (lastStep !== step || lastUnit !== unit)) {
          curStartTime = moment(curTime);
          ret.processedMinutes += minutesFromStart;
          minutes -= minutesFromStart;
          minutesFromStart = 0;
        }
        lastStep = step;
        lastUnit = unit;

        const stepPrices = fullStep.prices;
        let fullStepOverTime = 0;
        // If after 0 price is missing
        if (stepPrices[0].after > 0 && minutesFromStart < stepPrices[0].after) {
          let preStep = stepPrices[0].after - minutesFromStart;
          fullStepOverTime = curRule.maxMinutes ? (ret.processedMinutes + minutesFromStart
              + preStep) - curRule.maxMinutes : 0;
          if (fullStepOverTime > 0) {
            preStep -= fullStepOverTime;
          }
          fullStepRows.push({
            ruleNr: ret.ruleIndex + 1,
            from: moment(curTime),
            to: moment(curTime).add(preStep, 'm'),
            price: 0,
            step: preStep,
          });
          minutesFromStart = stepPrices[0].after;
          curTime.add(minutesFromStart, 'm');
          if (fullStepOverTime > 0) {
            minutes -= fullStepOverTime;
            minutesFromStart -= fullStepOverTime;
            curTime.subtract(fullStepOverTime, 'm');
            if (curRule.maxTime !== '') {
              ret.rows.push({ ruleNr: ret.ruleIndex + 1, maxTime: maxTimeDate });
            } else {
              ret.rows.push({ ruleNr: ret.ruleIndex + 1, maxMinutes: curRule.maxMinutes });
            }
          }
        }

        if (minutesFromStart < minutes) {
          // Find price with suitable step.after
          for (let j = stepPrices.length - 1; j >= 0; j -= 1) {
            if (minutesFromStart >= stepPrices[j].after) {
              if (unit === 'month') {
                if (!monthlyStartTime) { monthlyStartTime = moment(curTime); }
                step = this.getMonthlyStep(curTime, step, monthlyStartTime);
              }
              // Check max parking time
              fullStepOverTime = curRule.maxMinutes ? (ret.processedMinutes + minutesFromStart
                + step) - curRule.maxMinutes : 0;
              if (fullStepOverTime > 0) {
                step -= fullStepOverTime;
              }
              if (step > 0) {
                // TODO: unit is always minutes
                fullStepRows.push({
                  ruleNr: ret.ruleIndex + 1,
                  from: moment(curTime),
                  to: moment(curTime).add(step, 'm'),
                  price: stepPrices[j].price,
                  step,
                  // unit,
                });
                fullStepPrice += stepPrices[j].price;
                minutesFromStart += step;
              }
              if (fullStepOverTime > 0) {
                minutes -= fullStepOverTime;
                if (curRule.maxTime !== '') {
                  fullStepRows.push({ ruleNr: ret.ruleIndex + 1, maxTime: maxTimeDate });
                } else {
                  fullStepRows.push({ ruleNr: ret.ruleIndex + 1, maxMinutes: curRule.maxMinutes });
                }
              }
              break;
            }
          }
        }

        // Use the minimum of subStep price and fullStep price
        if (subStepData && subStepData.price < fullStepPrice) {
          if (dayPriceLimit > 0.01) {
            if (dayPriceLimit - subStepData.price < 0) {
              subStepData.price = dayPriceLimit;
            }

            ret.price += subStepData.price;
            dayPriceLimit -= subStepData.price;

            if (dayPriceLimit < 0.01) {
              const lastRowIndex = subStepData.rows.length - 1;
              subStepData.rows[lastRowIndex].maxPrice = true;
              subStepData.rows[lastRowIndex].price = fullStepPrice;
            }

            ret.rows.push(...subStepData.rows);
          } else if (dayPriceLimit !== null) {
            ret.rows.push(...subStepData.rows);
          } else {
            ret.price += subStepData.price;
            ret.rows.push(...subStepData.rows);
          }

          ret.cappedPrice = subStepData.cappedPrice;
          ret.cappedTime = subStepData.cappedTime;
          ret.endTime = subStepData.endTime;
          ret.hasEnded = subStepData.hasEnded;
        } else {
          if (dayPriceLimit > 0.01) {
            if (dayPriceLimit - fullStepPrice < 0) {
              fullStepPrice = dayPriceLimit;
            }

            ret.price += fullStepPrice;
            dayPriceLimit -= fullStepPrice;

            if (dayPriceLimit < 0.01) {
              const lastRowIndex = fullStepRows.length - 1;
              fullStepRows[lastRowIndex].maxPrice = true;
              fullStepRows[lastRowIndex].price = fullStepPrice;
            }

            ret.rows.push(...fullStepRows);
          } else if (dayPriceLimit !== null) {
            fullStepRows.forEach((row) => {
              row.maxPrice = true;
              row.price = 0;
            });
            ret.rows.push(...fullStepRows);
          } else {
            ret.price += fullStepPrice;
            ret.rows.push(...fullStepRows);
          }

          ret.endTime = moment(curStartTime).add(minutesFromStart, 'm');
          // Check max parking time
          if (fullStepOverTime > 0) {
            ret.cappedTime = curRule.maxMinutes;
            ret.hasEnded = true;
            break;
          }
        }
        // Check max parking price
        // if (curRule.maxPrice && ret.previousPrice + ret.price >= curRule.maxPrice) {
        //   ret.cappedPrice = curRule.maxPrice;
        //   if (minutesFromStart < minutes) {
        //     ret.hasEnded = true;
        //   }
        //   break;
        // }
      }
      ret.processedMinutes += minutesFromStart;
      return ret;
    },
    /**
     *  Takes into account start time. If there is a month with less days it sets the step to the
     *  end of month and later back to the date of start time if the month is longer
     *  For example:
     *  31.03.2017 05:12 - 30.04.2017 23:59
     *  30.04.2017 23:59 - 31.05.2017 05:12
     */
    getMonthlyStep(startTime, step, monthlyStartTime) {
      const endTime = moment(startTime).add(step, 'M');
      if (monthlyStartTime) {
        const lastDateOfMonth = moment(endTime).endOf('month').date();
        if (endTime.date() === lastDateOfMonth && monthlyStartTime.date() > endTime.date()) {
          endTime.endOf('month').seconds(0).milliseconds(0);
        } else {
          endTime.date(monthlyStartTime.date())
            .hours(monthlyStartTime.hours())
            .minutes(monthlyStartTime.minutes());
        }
      }
      return endTime.diff(startTime) / 60000;
    },
    /**
     *  Get longest step fitting into price
     */
    // TODO: Might not work correctly if larger steps also contain "after" prices
    // TODO: months
    getMaxStep(maxPrice, steps) {
      for (let stepIndex = steps.length - 1; stepIndex >= 0; stepIndex -= 1) {
        if (steps[stepIndex].prices[0].price <= maxPrice) {
          return steps[stepIndex].step;
        }
      }
      return 9999999;
    },
    /**
     *  Returns full step (exact or more minutes than required) and substep (less minutes)
     *  Adds realStep which also reflects real minutes of monthly steps
     */
    findStepsAround(steps, minutes, maxStep, startTime, monthlyStartTime) {
      const ret = [];
      for (let stepIndex = steps.length - 1; stepIndex >= 0; stepIndex -= 1) {
        const stepData = {
          step: steps[stepIndex].step,
          unit: steps[stepIndex].unit,
          realStep: steps[stepIndex].step,
          prices: steps[stepIndex].prices,
        };
        if (stepData.unit === 'month') {
          stepData.realStep = this.getMonthlyStep(startTime, stepData.step, monthlyStartTime);
        }
        if ((maxStep.unit === stepData.unit && stepData.step <= maxStep.step)
            || (maxStep.unit === 'month' && stepData.unit !== 'month')
            || (maxStep.unit !== 'month' && stepData.unit === 'month'
                && stepData.realStep <= maxStep.step)) {
          if (stepData.realStep <= minutes) {
            if (ret.length === 0 || stepData.step !== ret[0].step
                || stepData.unit !== ret[0].unit) {
              ret.push(stepData);
            }
            return ret;
          }
          ret[0] = stepData;
        }
      }
      return ret;
    },
    /**
     *  Returns index of highest priority pricing rule active for the specified time
     */
    getPricingRuleIndex(rules, time) {
      for (let ruleIndex = rules.length - 1; ruleIndex >= 0; ruleIndex -= 1) {
        if (this.isInPeriod(time, rules[ruleIndex])) {
          return ruleIndex;
        }
      }
      return 0;
    },
    /**
     *  Returns whether the pricing rule is applicable for the specified time
     */
    isInPeriod(time, rule) {
      if (rule.startDate !== null && time.isBefore(rule.startDate)) {
        return false;
      }
      if (rule.endDate !== null && time.isAfter(rule.endDate)) {
        return false;
      }
      if (rule.weekdays.indexOf(time.isoWeekday() - 1) === -1) {
        return false;
      }
      const minutesOfDay = (time.hours() * this.minutes_in_hour) + time.minutes();
      if (!this.isWholeDay(rule.startMinutes, rule.endMinutes)) {
        if (rule.startMinutes < rule.endMinutes) {
          if (minutesOfDay < rule.startMinutes || minutesOfDay > rule.endMinutes) {
            return false;
          }
        } else if (minutesOfDay > rule.startMinutes || minutesOfDay < rule.endMinutes) {
          return false;
        }
      }
      return true;
    },
    isWholeDay(startMinutes, endMinutes) {
      return startMinutes === endMinutes + 1
          || startMinutes + this.minutes_in_day === endMinutes + 1;
    },
    priceTestSliderEvent(val) {
      if (this.parkingTimeMutating) {
        return;
      }
      this.parkingTimeMutating = true;
      this.priceTestData.parkingTime = val;
      this.priceTestRecalculate();
    },
    priceTestPeriodChanged() {
      if (this.parkingTimeMutating) {
        return;
      }
      this.parkingTimeMutating = true;
      const minutes = this.priceTestData.parkingTime;
      const sliderValues = this.priceTestData.slider.data;
      let i = 0;
      while (i < sliderValues.length && sliderValues[i] <= minutes) {
        i += 1;
      }
      this.$refs.priceTestSlider.setIndex(i - 1);
      this.priceTestRecalculate();
    },
    priceTestRecalculate() {
      const startTime = moment(this.priceTestData.startTime, this.date_time_format);
      this.priceTestData.endTime = moment(startTime).add(this.priceTestData.parkingTime, 'm');
      this.priceTestData.result = null;
      this.priceTestData.result = this.calculatePrice(startTime, this.priceTestData.parkingTime);
      this.parkingTimeMutating = false;
    },
    hasSteps() {
      let ret = false;
      this.pricingrules.forEach((el) => {
        if (el.steps.length > 0) {
          ret = true;
        }
      });
      return ret;
    },
  },
  data() {
    const SLIDER_VALUES = [];
    for (let i = 0; i < 4 * 60; i += 2) {
      SLIDER_VALUES.push(i);
    }
    for (let i = 4 * 60; i < 12 * 60; i += 5) {
      SLIDER_VALUES.push(i);
    }
    for (let i = 12 * 60; i < 30 * 60; i += 15) {
      SLIDER_VALUES.push(i);
    }
    for (let i = 30 * 60; i < 7 * 24 * 60; i += 60) {
      SLIDER_VALUES.push(i);
    }
    for (let i = 7 * 24 * 60; i < 50 * 24 * 60; i += 6 * 60) {
      SLIDER_VALUES.push(i);
    }
    const startTime = moment();
    return {
      currency: process.env.CURRENCY,
      currency_short: process.env.CURRENCY_SHORT,
      minutes_in_hour: 60,
      date_time_format: 'DD.MM.YYYY HH:mm',
      minutes_in_day: 24 * 60,
      deleteRuleId: null,
      showConfirmationModal: false,
      showWarningModal: false,
      priceTestData: {
        startTime,
        parkingTime: null,
        slider: {
          value: 0,
          tooltip: false,
          piecewise: false,
          data: SLIDER_VALUES,
        },
        parkingTimeMutating: false,
        startWeekday: startTime.format('dd'),
        endTime: null,
        result: { price: null },
      },
      pickerOptions: {
        firstDayOfWeek: 1,
      },
    };
  },
  filters: {
    formatDateWithWeekday(momentDate) {
      return momentDate == null ? '' : moment(momentDate).format('DD.MM.YYYY HH:mm, dd');
    },
  },
};
</script>

<style lang="scss" scoped>
  .rule {border: 1px solid #ccc; padding: 10px; margin: 10px;}
  .add {float: right;}
  .edit {float: right; margin-left: 10px; cursor: pointer; color: 6688dd;}
  .remove {float: right; margin-left: 10px; cursor: pointer; color: 6688dd;}
  .priceafter {color:grey; width: 160px; display: inline-block;}
  .pricestep {width: 120px; display: inline-block;}
  .datePeriod {color: red;}
  .testDetails {height: 190px; overflow: auto; margin-left: 20px;}
  .pricetest label {width: 200px; display: inline-block; padding-top: 22px;}
  .ruletable .price {text-align: right; padding-left: 20px;}
  .ruletable {

    @media screen and (max-width: 400px) {
      width: 100%;
    }

    tr td {
      @media screen and (max-width: 400px) {
        display: table-row;
        padding-left: 0 !important;
        text-align: left !important;
        width: 100%;
        height: auto;
      }
    }

  }

  .pricetest {

    label {

      @media screen and (max-width: 700px) {
        display: block;
        margin-right: 0;
        width: 100%;
      }

    }

  }

</style>



// WEBPACK FOOTER //
// src/components/pricingrules/PricingRules.vue